import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { viewDriveItem, DriveItemOrigin, getOrFetchDriveItemMeta, viewableInGallery, PublicationOptions } from '../../containers/DriveItemList/actions';
import { Api } from '../../typings/api';
import RoutesUtils from '../../utils/routes';
import UserAgentUtils from '../../utils/userAgent';

interface ViewDriveItemPageParams {
	driveItemId: string;
	page?: string;
}

interface ViewDriveItemPageProps {
	dispatch: Dispatch<StoreState>;
	params: ViewDriveItemPageParams;
}

const ViewDriveItemPage = ({ dispatch, params}: ViewDriveItemPageProps) => {

	const redirectToDriveItemPage = async (): Promise<void> => {
		const driveItemId = getDriveItemId();
		const page = getPage();

		try {
			const driveItem = await dispatch(getOrFetchDriveItemMeta(driveItemId)) as Api.DriveItem;

			if (Object.keys(driveItem).length === 0) { // handle case where driveItem is {}
				redirectToHome();
				return;
			}

			const publicationOption: PublicationOptions = {
				page,
				hideWelcomePage: !!page,
			};
			dispatch(viewDriveItem(driveItem, DriveItemOrigin.List, publicationOption, true));

			const notRedirected = !viewableInGallery.includes(driveItem.type) && UserAgentUtils.isMobileApp;
			if (notRedirected) {
				redirectToHome();
			}
		} catch (error) {
			redirectToHome();
		}
	};

	const getDriveItemId = (): number => {
		return parseInt(params.driveItemId, 10);
	};

	const getPage = (): number | undefined => {
		if (params.page) {
			return parseInt(params.page, 10);
		}

		return undefined;
	};

	const redirectToHome = () => {
		RoutesUtils.historyPush(RoutesUtils.getPathHome());
	};

	React.useEffect(() => {
		redirectToDriveItemPage();
	}, [params]);

	return null;
};

export default ViewDriveItemPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ViewDriveItemPage/index.tsx